var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"home"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("有职Offer")]),_c('p',[_vm._v("助您走稳职场的第一步")])])])])
}]

export { render, staticRenderFns }